import TemplateSurveyState from 'containers/SurveyPage/TemplateSurveyState';
import { transformPropsDeep } from 'containers/App/utils';
import { forEach } from 'lodash';
import { SURVEY_TYPE_PEEQ } from 'containers/Survey/constants';

const genericGenerator = ({ template, variables = [], surveyType }) => {
  // pass the fetchedXXXX options only
  // if you intend to use the relevant template as-is

  let {
    questionnaireTemplate,
    regularTargetingTemplate,
    peeqTargetingTemplate,
  } = template;
  const replaceVariables = (value) => {
    let newValue = value;
    forEach(variables, ({ name, value: text }) => {
      newValue = newValue.replace(
        new RegExp(`\\{\\{${name}\\}\\}`, 'gi'),
        text,
      );
    });

    return newValue;
  };

  if (variables.length > 0) {
    questionnaireTemplate = transformPropsDeep(questionnaireTemplate, {
      prompt: replaceVariables,
      htmlPrompt: replaceVariables,
      body: replaceVariables,
    });

    regularTargetingTemplate = transformPropsDeep(regularTargetingTemplate, {
      prompt: replaceVariables,
      htmlPrompt: replaceVariables,
      body: replaceVariables,
    });

    peeqTargetingTemplate = transformPropsDeep(peeqTargetingTemplate, {
      prompt: replaceVariables,
      htmlPrompt: replaceVariables,
      body: replaceVariables,
    });
  }

  const Survey = new TemplateSurveyState({
    fetchedQuestionnaire: questionnaireTemplate,
    fetchedTargeting:
      surveyType === SURVEY_TYPE_PEEQ
        ? peeqTargetingTemplate
        : regularTargetingTemplate,
  });

  return { state: Survey.state };
};

export default genericGenerator;
